define(["./directivesModule"], function (directivesModule) {
    "use strict";

    var safetyLimit = 20;

    /**
     * @ngdoc directive
     * @name nlgConditionalHeightFiller
     * @restrict A
     *
     * @description
     *
     * @param {string} nlgConditionalHeightFiller altura a ser aplicada ao elemento ou `auto` para que a altura seja ajustada
     * automaticamente de acordo com a altura do `browser window viewport`.
     * @param {expression} nlgConditionalHeightFillerActive (Opcional) Define se a diretiva está ativa. Padrão é FALSE.
     *
     * @example
     <example>
     <file name="nlg-conditional-height-filler.html">
     <!-- Inativa por padrão (não fará nada) -->
     <div nlg-conditional-height-filler="auto"></div>

     <!-- Ativa (aplicará a altura) -->
     <div nlg-conditional-height-filler="auto" nlg-conditional-height-filler-active="true"></div>

     <!-- Controlada por uma variável -->
     <div nlg-conditional-height-filler="auto" nlg-conditional-height-filler-active="ctrl.isFillerActive"></div>
     </file>
     </example>
     */
    return directivesModule.directive("nlgConditionalHeightFiller", ["$window", function ($window) {
        return {
            restrict: "A",
            link: function (scope, element, attrs) {
                var heightValue = attrs.nlgConditionalHeightFiller;

                function setNewHeight(newHeight) {
                    var isActive = attrs.nlgConditionalHeightFillerActive !== undefined
                        ? scope.$eval(attrs.nlgConditionalHeightFillerActive)
                        : false;

                    if (isActive) {
                        element.height(newHeight);
                    } else {
                        element.css("height", "");
                    }
                }

                if (heightValue === "auto") {
                    scope.$watch(function () {
                        return $window.innerHeight - element.offset().top - safetyLimit;
                    }, setNewHeight);
                } else if (heightValue) {
                    scope.$watch(function () {
                        return attrs.nlgConditionalHeightFiller;
                    }, setNewHeight);
                }


                if (attrs.nlgConditionalHeightFillerActive) {
                    scope.$watch(attrs.nlgConditionalHeightFillerActive, function () {
                        var currentHeight = (heightValue === "auto")
                            ? $window.innerHeight - element.offset().top - safetyLimit

                            : attrs.nlgConditionalHeightFiller;

                        setNewHeight(currentHeight);
                    });
                }
            }
        };
    }]);
});